import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  onCloseDropdown: () => void;
}

export const EmptyState = ({ onCloseDropdown }: EmptyStateProps) => {
  const { t } = useTranslation('alerts', { useSuspense: false });
  const navigate = useNavigate();
  const { trackAlertsPageOpen } = usePosthogEvents();

  return (
    <div className={styles.root}>
      <img
        src="/app/static/images/empty-state/radio-telescope.png"
        width={160}
        height={160}
        alt=""
      />
      <div className={styles.textWrapper}>
        <div className={styles.title}>{t('alerts:emptyState.title')}</div>
        <div
          className={styles.viewPastNotificationsButton}
          onClick={() => {
            trackAlertsPageOpen(POSTHOG_TRACKING_SOURCES.ALERTS_DROPDOWN);
            navigate(appPaths.alerts);
            onCloseDropdown();
          }}
        >
          {t('alerts:emptyState.viewPastNotifications')}
        </div>
      </div>
    </div>
  );
};
